// src/components/store/sections/faqs/FaqV92AccordioncleanCoralFlame.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV92AccordioncleanCoralFlame(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={92}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
